import { useEffect } from 'react';
import { useIsFirstRender } from './useIsFirstRender';
export function useUpdateEffect(effect, deps) {
  var isFirst = useIsFirstRender();
  useEffect(() => {
    if (!isFirst) effect(); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);
}
//# sourceMappingURL=useUpdateEffect.js.map